// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"9ddf535f","66":"fbab4c33","223":"7437f10a","390":"90b105d5","397":"d1053daf","470":"4427aa0c","488":"3002016d","580":"8ac0866a","589":"73b24c43","607":"d4708145","913":"c4608846","974":"9cf5962e"}[chunkId] + ".chunk.js";
};